module.exports = __webpack_public_path__ + "img/whatsapp.acbb4b53.png";